import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ArticleItem } from '../../services/site.model';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent implements OnInit {

    services: ArticleItem[] = [];

    constructor(
        private translate: TranslateService
    ) { }

    ngOnInit(): void {
        this.services = this.getServices();
    }

    getServices(): ArticleItem[] {
        return [
            {
                icon: 'icon-maintenance',
                title: 'Collision & Repair',
                subtitle: 'We repair your vehicle quickly using the correct OEM repair procedures to ensure you have a quality and safe repair.'
            } as ArticleItem,
            // {
            //     icon: 'icon-pickup',
            //     title: 'Vehicle Pick up & Delivery',
            //     subtitle: 'We allow free client car tow service. Makes it easy to place your vehicle in the hands of professionals you can trust, so you can get back on the road with confidence.'
            // } as ArticleItem,
            {
                icon: 'icon-building',
                title: 'Free On-Site Estimate',
                subtitle: 'We visit a client\'s property or site and the technicians at Best Auto Body will estimate the service client need.'
            } as ArticleItem,
            {
                icon: 'icon-spray-gun',
                title: 'Painting',
                subtitle: 'Your vehicle’s paint is often the first thing people notice—especially if the finish is chipped, scratched, or damaged. We will perform a thorough  restoration of the paint.'
            } as ArticleItem,
            {
                icon: 'icon-wheel',
                title: 'Wheel & Tire',
                subtitle: 'We’re here to help you with tire & wheel selection, professional installation, and preventive maintenance for a long tire life.'
            } as ArticleItem,
        ];
    }
}
